import React, { Component } from 'react';
import Dropdown from '../Dropdown';
import { toSelectFormat } from '../../../../main/support/utils';
const PLATFORM_OPTIONS = [
  {
    label: 'ios',
    value: 'IOS',
  },
  {
    label: 'android',
    value: 'ANDROID',
  },
];
const TIME_OPTIONS = [
  {
    label: 'seconds',
    value: 'seconds_from_last_attributed_touch_to_event',
  },
  {
    label: 'minutes',
    value: 'minutes_from_last_attributed_touch_to_event',
  },
  {
    label: 'hours',
    value: 'hours_from_last_attributed_touch_to_event',
  },
  {
    label: 'days',
    value: 'days_from_last_attributed_touch_to_event',
  },
];
type Props = {
  compareByFilterOptions: Array<string>;
  osFilters: Array<string>;
  time: string;
  compareByFilters: Array<string>;
  updateCompareByFilters: (filters: Array<string>, dimensionsToFilters: Record<string, any>) => void;
  updatePlatformFilters: (filters: Array<string>) => void;
  updateTime: (time: string) => void;
  dimensionsToFilters: Record<string, any>;
  compareByDimensions: Array<string>;
  fetchFilters: (...args: Array<any>) => any;
};
type State = {
  loading: boolean;
};

class DistributionCompareBy extends Component<Props, State> {
  state = {
    loading: true,
  };

  componentDidMount() {
    const { fetchFilters, compareByDimensions } = this.props;
    fetchFilters(compareByDimensions).finally(() => {
      this.setState({
        loading: false,
      });
    });
  }

  render() {
    const {
      compareByFilterOptions,
      osFilters,
      time,
      compareByFilters,
      updateCompareByFilters,
      updatePlatformFilters,
      updateTime,
      dimensionsToFilters,
    } = this.props;
    const toSelectFilterOptions = toSelectFormat(compareByFilterOptions);
    return (
      <div className="analytics-filters__row h_ai-c">
        <div className="h_d-f h_w-100">
          <span className="h_fw-600 h_ta-end h_mt-5">Compare CTI time for</span>
          <Dropdown
            multi={true}
            options={toSelectFilterOptions}
            onChange={(e) =>
              updateCompareByFilters(
                e.map((c) => c.value),
                dimensionsToFilters
              )
            }
            value={compareByFilters}
            outerClassName="h_mstart-10 distribution-compare-by__filter"
            i13nLabel="Distribution Compare By - Filter CTI Time"
            testid="dist-compare-by__filter-cti"
            isLoading={this.state.loading}
          />
          <span className="h_fw-600 h_mstart-20 h_mt-5">OS</span>
          <Dropdown
            multi={true}
            clearable={false}
            options={PLATFORM_OPTIONS}
            onChange={(e) => updatePlatformFilters(e.map((c) => c.value))}
            value={osFilters}
            outerClassName="h_mstart-10 distribution-compare-by__os-filter"
            i13nLabel="Distribution Compare By - Filter OS"
            testid="dist-compare-by__filter-os"
          />
          <div className="h_d-f h_jc-fe distribution-compare-by__filter">
            <span className="h_fw-600 h_mstart-20 h_mt-5">CTI time in</span>
            <Dropdown
              options={TIME_OPTIONS}
              onChange={(e) => updateTime(e.value)}
              value={time}
              clearable={false}
              className="source-row__select"
              i13nLabel="Distribution Compare By - Select Time"
              testid="dist-compare-by__select-time"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DistributionCompareBy;
